/* eslint-disable quote-props */
/* eslint-disable max-len */
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { etoileEspeces } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_pres_035: Question = {
  id: 'pres-035-especes-plan-retablissement',
  oldId: '49',
  title: 'Nombre d’espèces touchées par un plan de rétablissement',
  number: '3.19',
  description: [''],
  type: QuestionType.INDICATOR,
  frequency: 1,
  slots: [
    {
      type: SlotTypes.ETOILES,
      items: [''],
      data: ['0'],
      scoreCalculatedLater: false,
      optional: false,
      scoringFct: (data:number) => {
        if (data >= 3) return 3;
        if (data >= 2) return 2;
        if (data >= 1) return 1;
        return 0;
      },
      score: '0',
      maxScore: 3,
      help: etoileEspeces,
      unit: SlotUnit.NUMBER_OF,
    },
  ],
};

export const question_pres_035_v2: Question = question_pres_035;
export const question_pres_035_v3: Question = question_pres_035;
